import React, { useEffect, useState } from "react";
import { cn } from "../../lib/utils";
import { getCachedBranding } from "../../lib/branding";

/**
 * Logo da empresa atual. Só exibe a logo da PRÓPRIA loja:
 * - usa `company.logoUrl` (GET /companies/{code});
 * - enquanto a API não responde, usa a logo da última visita (cache de branding,
 *   escopado por empresa — ver lib/branding.js e config/company.js);
 * - sem logo (ou se a imagem falhar) mostra um espaço reservado neutro,
 *   nunca a logo de outra loja.
 *
 * @param {Object|null} company - Dados da empresa (useCompany)
 * @param {string} [alt] - Texto alternativo
 * @param {string} [className] - Classes da <img>/placeholder
 */
export const CompanyLogo = ({ company = null, alt = "", className }) => {
  const src = company?.logoUrl || getCachedBranding()?.logoUrl || "";
  const [failed, setFailed] = useState(false);
  const [loaded, setLoaded] = useState(false);

  // Nova URL (cache → API): tenta carregar de novo
  useEffect(() => {
    setFailed(false);
    setLoaded(false);
  }, [src]);

  if (!src || failed) {
    return (
      <span
        aria-hidden="true"
        className={cn(
          "block rounded-xl bg-cream-200",
          !company && "animate-pulse",
          className
        )}
      />
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      onLoad={() => setLoaded(true)}
      onError={() => setFailed(true)}
      className={cn(
        "transition-opacity duration-200",
        loaded ? "opacity-100" : "opacity-0",
        className
      )}
    />
  );
};

export default CompanyLogo;
